import React, { FC } from 'react';

import { InputNumber, InputNumberProps } from 'antd';

export interface NumberInputProps extends Omit<InputNumberProps, 'onChange'> {
  onChange?: (value: string | number | null) => void;
}

export const NumberInput: FC<NumberInputProps> = ({
  value,
  onChange,
  ...rest
}) => (
  <InputNumber
    value={value}
    onChange={onChange}
    style={{ width: '100%' }}
    controls
    {...rest}
  />
);
